export default {
  "zh-CN": {
    studioUi: {
      stopLive: "关播",
      tiktokStartTitle: "连接 TikTok 直播",
      tiktokStartDescription: "填写 TikTok ID，确认 TikTok 正在直播后，StarLive 会自动读取直播封面并立即开播，无需审核。",
      liveAlreadyActive: "正在直播",
      tiktokId: "TikTok ID",
      tiktokIdPlaceholder: "例如：starlive_host",
      tiktokStartTip: "StarLive 会读取 TikTok 的直播封面、标题和播放流；未开播时不会改变直播状态。",
      tiktokChecking: "正在确认直播…",
      confirmStartLive: "确认并开始直播",
      liveSourceTip: "输入 TikTok ID 后直接开播，直播封面由 TikTok 自动同步，无需创建直播间或提交审核。",
      requiredTip: "请填写标题和必要内容"
    },
    studioManager: {
      startLiveTip: "输入 TikTok ID 并确认真实开播状态",
      giftDetail: "礼物明细",
      giftDetailEyebrow: "LIVE GIFT LEDGER",
      giftCoins: "收到金币",
      giftOrders: "赠送次数",
      giftQuantity: "礼物数量",
      giftItem: "{gift} × {count}",
      noLiveGifts: "本场暂无礼物",
      noLiveGiftsTip: "用户在本场直播赠送礼物后，详细记录会显示在这里。"
    },
    errors: {
      "CONTENT.PLAY_URL_REQUIRED": "请为短视频填写播放地址。",
      "LIVE.INVALID_TIKTOK_ID": "TikTok ID 应为 2 - 24 位字母、数字、下划线或小数点。",
      "LIVE.INVALID_GAME_URL": "弹幕游戏地址必须是有效的 HTTPS 网页地址。",
      "LIVE.ALREADY_ACTIVE": "你已经有一场正在进行的直播，请先结束当前直播。",
      "LIVE.DIRECT_START_ONLY": "直播无需创建草稿，请填写 TikTok ID 直接开播。",
      "LIVE.TIKTOK_NOT_LIVE": "没有检测到该 TikTok ID 正在直播，请先在 TikTok 开播。",
      "LIVE.TIKTOK_UPSTREAM_UNAVAILABLE": "暂时无法连接 TikTok，请稍后重试。",
      "LIVE.STREAM_NOT_FOUND": "已检测到直播间，但暂时没有可播放的直播流。",
      "LIVE.REALTIME_UNAVAILABLE": "直播互动暂时无法实时连接，正在使用低频同步。",
      "LIVE.ENDED": "本场直播已经结束。",
      "LIVE.CHAT_SENSITIVE": "聊天内容包含不适宜信息，请修改后再发送。"
    }
  },
  "en-US": {
    studioUi: {
      stopLive: "End live",
      tiktokStartTitle: "Connect TikTok Live",
      tiktokStartDescription: "Enter the TikTok ID. Once TikTok is confirmed live, StarLive imports the live cover and starts the session immediately without review.",
      liveAlreadyActive: "Live now",
      tiktokId: "TikTok ID",
      tiktokIdPlaceholder: "Example: starlive_host",
      tiktokStartTip: "StarLive imports the TikTok live cover, title, and stream. The live status will not change if the account is offline.",
      tiktokChecking: "Checking live status…",
      confirmStartLive: "Verify & go live",
      liveSourceTip: "Enter a TikTok ID to go live directly. The TikTok live cover is imported automatically; no room draft or review is required.",
      requiredTip: "Enter the title and required information"
    },
    studioManager: {
      startLiveTip: "Enter a TikTok ID and verify the live session",
      giftDetail: "Gift details",
      giftDetailEyebrow: "LIVE GIFT LEDGER",
      giftCoins: "Gift coins",
      giftOrders: "Gift events",
      giftQuantity: "Gift quantity",
      giftItem: "{gift} × {count}",
      noLiveGifts: "No gifts in this live",
      noLiveGiftsTip: "Detailed records will appear here when viewers send gifts during this live."
    },
    errors: {
      "CONTENT.PLAY_URL_REQUIRED": "Enter a playback URL for the short video.",
      "LIVE.INVALID_TIKTOK_ID": "Use 2–24 letters, numbers, underscores, or periods for the TikTok ID.",
      "LIVE.INVALID_GAME_URL": "The interactive game URL must be a valid HTTPS page.",
      "LIVE.ALREADY_ACTIVE": "You already have an active live session. End it before starting another.",
      "LIVE.DIRECT_START_ONLY": "Live sessions do not use drafts. Enter a TikTok ID to go live directly.",
      "LIVE.TIKTOK_NOT_LIVE": "This TikTok ID is not live. Start streaming on TikTok first.",
      "LIVE.TIKTOK_UPSTREAM_UNAVAILABLE": "TikTok cannot be reached right now. Try again later.",
      "LIVE.STREAM_NOT_FOUND": "The room is live, but no playable stream is currently available.",
      "LIVE.REALTIME_UNAVAILABLE": "Live interactions cannot connect in real time. Low-frequency sync is active.",
      "LIVE.ENDED": "This live session has ended.",
      "LIVE.CHAT_SENSITIVE": "This message contains restricted content. Edit it and try again."
    }
  },
  "ar-SA": {
    studioUi: {
      stopLive: "إنهاء البث",
      tiktokStartTitle: "ربط بث TikTok",
      tiktokStartDescription: "أدخل معرّف TikTok. بعد التأكد من أن الحساب مباشر، يستورد StarLive غلاف البث ويبدأ الجلسة فورًا دون مراجعة.",
      liveAlreadyActive: "مباشر الآن",
      tiktokId: "معرّف TikTok",
      tiktokIdPlaceholder: "مثال: starlive_host",
      tiktokStartTip: "يستورد StarLive غلاف بث TikTok وعنوانه ورابطه. لن تتغير حالة البث إذا لم يكن الحساب مباشرًا.",
      tiktokChecking: "جارٍ التحقق من البث…",
      confirmStartLive: "تحقق وابدأ البث",
      liveSourceTip: "أدخل معرّف TikTok لبدء البث مباشرة. يتم استيراد غلاف TikTok تلقائيًا دون إنشاء غرفة أو انتظار المراجعة.",
      requiredTip: "أدخل العنوان والمعلومات المطلوبة"
    },
    studioManager: {
      startLiveTip: "أدخل معرّف TikTok وتحقق من جلسة البث",
      giftDetail: "تفاصيل الهدايا",
      giftDetailEyebrow: "سجل هدايا البث",
      giftCoins: "عملات الهدايا",
      giftOrders: "مرات الإهداء",
      giftQuantity: "عدد الهدايا",
      giftItem: "{gift} × {count}",
      noLiveGifts: "لا توجد هدايا في هذا البث",
      noLiveGiftsTip: "ستظهر السجلات التفصيلية هنا عندما يرسل المشاهدون هدايا أثناء هذا البث."
    },
    errors: {
      "CONTENT.PLAY_URL_REQUIRED": "أدخل رابط تشغيل للفيديو القصير.",
      "LIVE.INVALID_TIKTOK_ID": "يجب أن يتكون معرّف TikTok من 2 إلى 24 حرفًا أو رقمًا أو شرطة سفلية أو نقطة.",
      "LIVE.INVALID_GAME_URL": "يجب أن يكون رابط اللعبة التفاعلية صفحة HTTPS صالحة.",
      "LIVE.ALREADY_ACTIVE": "لديك جلسة بث نشطة بالفعل. أنهِها قبل بدء جلسة أخرى.",
      "LIVE.DIRECT_START_ONLY": "لا تستخدم جلسات البث المسودات. أدخل معرّف TikTok وابدأ مباشرة.",
      "LIVE.TIKTOK_NOT_LIVE": "هذا الحساب لا يبث على TikTok الآن. ابدأ البث هناك أولًا.",
      "LIVE.TIKTOK_UPSTREAM_UNAVAILABLE": "يتعذر الاتصال بـ TikTok حاليًا. حاول لاحقًا.",
      "LIVE.STREAM_NOT_FOUND": "الغرفة مباشرة، لكن لا يتوفر بث قابل للتشغيل الآن.",
      "LIVE.REALTIME_UNAVAILABLE": "يتعذر الاتصال بالتفاعلات مباشرة الآن، ويجري استخدام مزامنة منخفضة التكرار.",
      "LIVE.ENDED": "انتهت جلسة البث هذه.",
      "LIVE.CHAT_SENSITIVE": "تحتوي الرسالة على محتوى غير مسموح. عدّلها وحاول مجددًا."
    }
  }
}
